/* Premium visual modernization — Skeleton placeholder.
 *
 * A shimmering placeholder block (see `.pm-skeleton` in index.css) used
 * while data loads, instead of a bare spinner. Purely presentational;
 * `aria-hidden` so screen readers skip it (the container carries
 * `aria-busy`). Shimmer auto-disables under prefers-reduced-motion.
 */

import type { CSSProperties, JSX } from 'react';

interface SkeletonProps {
  width?: string | number;
  height?: string | number;
  radius?: string | number;
  className?: string;
  style?: CSSProperties;
}

export function Skeleton({
  width = '100%',
  height = 16,
  radius,
  className,
  style,
}: SkeletonProps): JSX.Element {
  return (
    <div
      className={`pm-skeleton${className ? ` ${className}` : ''}`}
      style={{ width, height, ...(radius !== undefined ? { borderRadius: radius } : {}), ...style }}
      aria-hidden="true"
    />
  );
}
